export { default } from "./VideoMobilePresentModeQuiz";
